<template>
    <div class="pa-4 text-center">
        <v-dialog v-model="dialog" max-width="600">
            <v-card>
                <v-card-title>
                    <TitleOfDialog title="Select options" @close="emit('close')" />
                </v-card-title>

                <v-divider />

                <v-card-text>
                    <v-row justify="center" align="center">
                        <v-col cols="12" md="4">
                            <h5>Interval (Sec)</h5>
                            <v-number-input :min="1" control-variant="split" variant="plain" color="primary"
                                density="compact" center-affix v-model="interval" />
                        </v-col>

                        <v-col cols="12" md="4">
                            <h5>Data type</h5>
                            <v-radio-group color="primary" v-model="recordsType" :disabled="active_mission">
                                <v-radio v-for="recordType in types" :key="recordType.value" :label="recordType.label"
                                    :value="recordType.value" />
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="red" variant="plain" text="Cancel" @click="emit('close')" />
                    <v-btn color="green" variant="plain" text="Accept" @click="accept" />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import TitleOfDialog from '../base/TitleOfDialog.vue';

const props = defineProps({
    active_mission: Boolean
});

const dialog = defineModel('dialog')

const emit = defineEmits(['close', 'accept']);

const types = ref([
    { label: 'History records', value: 'log' },
    { label: 'Live records', value: 'live' }
]);

const interval = ref(60);
const recordsType = ref(types.value[0].value);

watch(
    () => props.active_mission,
    (value) => {
        recordsType.value = value ? types.value[1].value : types.value[0].value;
    },
    { immediate: true }
);

const accept = () => {
    emit('accept', interval.value, recordsType.value);
    emit('close');
};
</script>